/**
 * Mekke 認証フック
 * 共通フックを使用（ゲスト非対応）
 */
import { useNavigate } from "react-router-dom";
import { useAtom, useAtomValue } from "jotai";
import { useAuthCommon } from "@tabipla/hooks/auth";
import {
  userAtom,
  isAuthenticatedAtom,
  isLoadingAtom,
  isAuthCheckedAtom,
} from "../atoms/auth-atoms";
import { signIn, signUp, signOut } from "@/infrastructure/auth/auth-client";
import { apiClient } from "@/infrastructure/api/client";

export function useAuth() {
  const navigate = useNavigate();
  const [user, setUser] = useAtom(userAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
  const [, setIsAuthChecked] = useAtom(isAuthCheckedAtom);

  const authActions = useAuthCommon({
    apiClient,
    authClient: { signIn, signUp, signOut },
    setUser,
    setIsLoading,
    setIsAuthChecked,
    navigate,
    // guestSupport なし = ユーザー認証のみ
  });

  return {
    user,
    isAuthenticated,
    isLoading,
    ...authActions,
  };
}
